export interface ReusePaymentCardRequest {
  payment_id: string;
  payment_method_id: string | undefined;
}

export enum ReusePaymentCardStatus {
  KO = 'KO',
  PND = 'PND',
  OK = 'OK',
}

export enum ReusePaymentCardType {
  REC = 'REC',
}
